(() => {
  if (customElements.get('sd-shoe-size-chart')) return;
  class SdShoeSizeChart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-size-chart-open]');
      if (!this.dialog || !this.trigger) return;
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('sd-size-chart-modal-open');
      });
      this.querySelector('[data-size-chart-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        if (!document.querySelector('sd-shoe-size-chart dialog[open]')) document.documentElement.classList.remove('sd-size-chart-modal-open');
        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
    }
  }
  customElements.define('sd-shoe-size-chart', SdShoeSizeChart);
})();
